module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lazy) ? _c('img', {
    style: ({
      'border-radius': ((_vm.radius || 0) + "px")
    }),
    attrs: {
      "defaultimg": _vm.lazyImage,
      "datalazy": _vm.imageSrc,
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }) : (!_vm.lazy && _vm.imageLoad) ? _c('img', {
    style: ({
      'border-radius': ((_vm.radius || 0) + "px")
    }),
    attrs: {
      "src": _vm.imageSrc,
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58a6acbc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/image/index.vue
// module id = 69
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 32 33 34 36 37 38 39 40 41 44 45 47 55 64 65 66 67 69 71 72 76 78 81 84 108